import React, { useEffect, useState } from 'react';
import { adminStats } from '../../lib/api';
import { Package, ShoppingBag, MessageSquare, Mail, DollarSign, Loader2 } from 'lucide-react';

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className="bg-white rounded-lg p-5 shadow-sm border border-neutral-200">
    <div className="flex items-center justify-between">
      <span className="text-xs uppercase tracking-wider text-neutral-500 font-bold">{label}</span>
      <div className={`w-9 h-9 rounded-full flex items-center justify-center ${accent || 'bg-neutral-100'}`}><Icon className="w-4 h-4" /></div>
    </div>
    <div className="text-3xl font-black mt-3">{value}</div>
  </div>
);

const AdminOverview = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminStats().then(setStats).catch(console.error); }, []);

  if (!stats) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-neutral-400" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-black mb-1">Overview</h1>
      <p className="text-sm text-neutral-500 mb-6">Welcome back. Here's a snapshot of your store.</p>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <Stat icon={DollarSign} label="Revenue" value={`$${stats.revenue.toFixed(2)}`} accent="bg-[#bfff00]/30" />
        <Stat icon={ShoppingBag} label="Orders" value={stats.orders} />
        <Stat icon={Package} label="Products" value={stats.products} />
        <Stat icon={MessageSquare} label="Messages" value={stats.messages} />
        <Stat icon={Mail} label="Subscribers" value={stats.subscribers} />
      </div>

      <div className="mt-8 bg-white rounded-lg p-6 border border-neutral-200">
        <h2 className="font-black mb-3">Quick tips</h2>
        <ul className="text-sm space-y-2 text-neutral-700 list-disc pl-5">
          <li>Use <strong>Products</strong> to add, edit prices, change stock, or remove items.</li>
          <li>Use <strong>Orders</strong> to view customer purchases and update status (pending → shipped → delivered).</li>
          <li>Check <strong>Messages</strong> daily for customer support requests.</li>
          <li>Your <strong>Newsletter</strong> list is your most valuable asset — export emails to send promos.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminOverview;
